<template>
  <draggable
    v-bind="dragOptions"
    @start="drag = true"
    @end="drag = false"
    class="list-group"
    @update="update"
    v-model="checkedList"
  >
    <transition-group type="transition" name="flip-list">
      <div
        v-for="(item, index) in checkedList"
        :key="item.prop"
        :class="{ 'padding-children': isChildren }"
      >
        <div
          class="flex-between flex-1 padding-y-3"
          v-if="item.prop !== 'sortIndex' && item.type !== 'selection'"
        >
          <div class="flex-start">
            <div
              v-if="!isChildren"
              :class="[item.fixed ? '' : 'handle']"
              class="padding-x-5 padding-y-2 margin-right-5"
            >
              <el-tooltip
                v-if="item.fixed"
                effect="dark"
                content="固定后不可移动位置"
                placement="top-start"
              >
                <i class="el-icon-info color-999 font-12"></i>
              </el-tooltip>
              <i v-else class="el-icon-rank font-12 color-333"></i>
            </div>
            <Checkbox
              :disabled="isChildren"
              :key="item.prop"
              v-model="item.checked"
              :label="item.label"
              @change="onItemChange($event, item, index)"
            />
          </div>
          <div
            v-if="!isChildren && showFixed"
            class="flex-1 flex flex-justify-end flex-align-center"
          >
            <el-tooltip effect="dark" content="固定在左侧" placement="top">
              <div
                @click="changeFixed(item, 'left', index)"
                class="padding-x-5 padding-y-2 pointer"
              >
                <i
                  class="el-icon-back font-16"
                  :class="[item.fixed === 'left' ? 'active' : '']"
                ></i>
              </div>
            </el-tooltip>
            <el-tooltip effect="dark" content="固定在右侧" placement="top">
              <div
                @click="changeFixed(item, 'right', index)"
                class="padding-x-5 padding-y-2 pointer"
              >
                <i
                  class="el-icon-right font-16"
                  :class="[item.fixed === 'right' ? 'active' : '']"
                ></i>
              </div>
            </el-tooltip>
          </div>
        </div>
        <TreeColumn
          :isChildren="true"
          :list="item.children"
          v-if="item.children && item.children.length > 0"
        />
      </div>
    </transition-group>
  </draggable>
</template>
<script>
  import { ref, watch, inject, computed } from '@vue/composition-api'
  import Checkbox from './check-box.vue'
  import { uuidv5 } from '@/util/util'
  import draggable from 'vuedraggable'
  export default {
    name: 'TreeColumn',
    components: {
      Checkbox,
      draggable
    },
    props: {
      list: {
        type: Array,
        default() {
          return []
        }
      },
      isChildren: {
        type: Boolean,
        default: false
      }
    },
    emits: ['onChange'],
    setup(props, { emit }) {
      const tableProps = inject('tableProps')

      const showFixed = computed(() => !tableProps.fixedTop.value)
      const checked = ref(true)
      const checkedList = ref([])
      const dragOptions = ref({
        animation: 300,
        group: 'columns',
        disabled: false,
        ghostClass: 'ghost',
        handle: '.handle'
      })
      let selectionData = null
      let indexData = null
      watch(
        () => props.list,
        (v) => {
          if (v.length > 0) {
            indexData = v.find((item) => item.prop === 'sortIndex')
            selectionData = v.find((item) => item.type === 'selection')
            checkedList.value = v.filter(
              (item) => item.type !== 'selection' && item.prop !== 'sortIndex'
            )
          }
        },
        {
          immediate: true
        }
      )
      const setList = () => {
        const data = [...checkedList.value]
        if (indexData) {
          data.unshift(indexData)
        }
        if (selectionData) {
          data.unshift(selectionData)
        }
        emit('onChange', data)
      }
      /* const setSiblings = (index, list) => {
        const prev = index - 1
        const next = index + 1
        const len = list.length
        if (prev !== -1) {
          checkedList.value[prev].id = uuidv5()
        }
        if (next <= len - 1) {
          checkedList.value[next].id = uuidv5()
        }
      } */
      const changeFixed = (item, type) => {
        item.fixed = item.fixed && item.fixed === type ? null : type
        checkedList.value = checkedList.value.map((item) => ({ ...item, id: uuidv5() }))
        setList()
      }
      const update = () => {
        checkedList.value = checkedList.value.map((item) => ({ ...item, id: uuidv5() }))
        setList()
      }

      const onItemChange = (e, item) => {
        checkedList.value = checkedList.value.map((item) => ({ ...item, id: uuidv5() }))
        setList()
      }
      return {
        onItemChange,
        showFixed,
        dragOptions,
        changeFixed,
        checked,
        update,
        checkedList
      }
    }
  }
</script>
<style scoped lang="scss">
  .padding-children {
    padding-left: 26px;
  }
  .flip-list-move {
    transition: transform 0.2s;
  }

  .no-move {
    transition: transform 0s;
  }
  .list-item {
    background-color: rgba(#f6f6f6, 0.8);
    border-radius: 2px;
  }
  .ghost {
    border: 1px dashed #1089ff;
  }

  .handle {
    cursor: move;
  }
  .column-list {
    max-height: 360px;
    overflow: auto;
  }
  .active {
    color: #1089ff;
  }
</style>
